import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { ChevronRightOutlined } from '@mui/icons-material';
import useOnboardCheck from '../TopNav/Hooks/useOnboardCheck';

const GlobalSidebar = ({ sections = [] }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const naviagte = useNavigate();
  const { pathname } = location;

  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
    };
  });
  const checkOnboarding = useOnboardCheck(loginUser?.is_firm_onboarded);
  const onNavigate = (path) => {
    if (!path) return;
    naviagte(path);
  };
  return (
    <Box
      sx={{
        padding: 2,
        overflowY: 'scroll',
        height: '100vh',
        backgroundColor: '#000',
      }}
    >
      {sections.map((section, sectionIndex) => (
        <Box key={sectionIndex}>
          <Typography
            sx={{
              marginTop: 3,
              marginBottom: 1.5,
              fontWeight: 'bold',
              color: '#fff',
            }}
          >
            {section.title}
          </Typography>

          {section.tabs.map((tab, index) =>
            tab?.showOptions ? (
              <Accordion
                key={index}
                sx={{
                  backgroundColor: '#000',
                  boxShadow: 'none',
                  '.MuiAccordionSummary-root': {
                    borderBottom: '1px solid gray',
                    alignItems: 'center',
                    borderBottom: 'none',
                    // py: 0
                  },
                  '&.Mui-expanded': {
                    margin: '0px',
                    // py: 0,
                  },
                  
                  py: 1,
                  marginY: '0px',
                }}
              >
                <AccordionSummary
                  className={`tab-ctr ${
                    tab.navigateTo === pathname ? 'active-tab-ctr' : ''
                  }`}
                  aria-controls={`panel-${sectionIndex}-${index}-content`}
                  id={`panel-${sectionIndex}-${index}-header`}
                  sx={{
                      backgroundColor: tab.navigateTo === pathname ? '#FFAB0029' : '',
                      boxShadow: 'none',
                      flexDirection: 'row',
                      alignItems: 'center',
                      borderRadius: '10px',
                      cursor: 'pointer',
                      borderBottom: 'none',
                      margin: 0,
                      '& .Mui-expanded': {
                        margin: '12px 0',
                        minHeight: 'unset',
                      }
                    }}
                >
                  <Box
                    className={`tab-ctr ${
                      tab.navigateTo === pathname ? 'active-tab-ctr' : ''
                    }`}
                    sx={{
                      flex: 1,
                      borderBottom: 'none',
                      py: 0,
                      bgcolor: tab.navigateTo === pathname ? '#FFAB0029' : '',
                      borderRadius: '10px',
                      cursor: 'pointer',
                      borderBottom: '0px',
                    }}
                  >
                    <Box className='icon-ctr'>{tab.iconSource}</Box>
                    <Typography
                      variant='button'
                      fontWeight={'600'}
                      sx={{
                        color:
                        tab.navigateTo === pathname ? '#FF9201' : '#9CA3AF',
                        textTransform: 'capitalize',
                      }}
                    >
                      {tab.title}
                    </Typography>
                    <ChevronRightOutlined
                      className='chevron'
                      sx={{
                        color:
                          tab.navigateTo === pathname ? '#FF9201' : '#9CA3AF',
                      }}
                    />
                  </Box>
                </AccordionSummary>
                <AccordionDetails sx={{ pt: 0 }}>
                  {tab.options.map((opt, optIndex) => (
                    <Box
                      key={optIndex}
                      onClick={() =>
                        opt?.isCheckOnboarding ? checkOnboarding(opt.navigateTo)
                          : onNavigate(opt.navigateTo)
                      }
                      className={`tab-ctr ${
                        opt.navigateTo === pathname ? 'active-tab-ctr' : ''
                      }`}
                      sx={{
                        bgcolor: opt.navigateTo === pathname ? '#FFAB0029' : '',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        pl: 4,
                        borderBottom: 'none',
                      }}
                    >
                      <Typography
                        variant='button'
                        fontWeight={'600'}
                        sx={{
                          color:
                            opt.navigateTo === pathname ? '#FF9201' : '#9CA3AF',
                            textTransform: 'capitalize',
                          }}
                      >
                        {opt.title}
                      </Typography>
                      <ChevronRightOutlined
                        className='chevron'
                        sx={{
                          color:
                            opt.navigateTo === pathname ? '#FF9201' : '#9CA3AF',
                        }}
                      />
                    </Box>
                  ))}
                </AccordionDetails>
              </Accordion>
            ) : (
              <Box
                key={index}
                className={`tab-ctr ${
                  tab.navigateTo === pathname ? 'active-tab-ctr' : ''
                }`}
                sx={{
                  bgcolor: tab.navigateTo === pathname ? '#FFAB0029' : '',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  px: 2,
                  borderBottom: 'none',
                }}
                onClick={() => {
                  dispatch({ type: 'RESET_FMCG_REDUCER' });
                  dispatch({ type: 'CLEAR_RETAILERS' });
                  dispatch({ type: 'RESET_BCM_ORDER' });

                  tab?.isCheckOnboarding
                    ? checkOnboarding(tab.navigateTo)
                    : onNavigate(tab.navigateTo);
                }}
              >
                <Box className='icon-ctr'>{tab.iconSource}</Box>
                <Typography
                  variant='button'
                  fontWeight={'600'}
                  sx={{
                    color: tab.navigateTo === pathname ? '#FF9201' : '#9CA3AF',
                    textTransform: 'capitalize',
                  }}
                >
                  {tab.title}
                </Typography>
                <ChevronRightOutlined
                  className='chevron'
                  sx={{
                    color: tab.navigateTo === pathname ? '#FF9201' : '#9CA3AF',
                  }}
                />
              </Box>
            ),
          )}
        </Box>
      ))}
    </Box>
  );
};

export default GlobalSidebar;
